export const buildQuickAppointmentPayload = ({ appointmentForm, quickCustomerForm, toIso }) => {
  const name = String(quickCustomerForm?.name || "").trim();
  if (!name) {
    throw new Error("Inserisci il nome del cliente rapido.");
  }

  const payload = {
    name,
    email: String(quickCustomerForm?.email || "").trim() || null,
    phone: String(quickCustomerForm?.phone || "").trim() || null,
    service_id: appointmentForm.service_id,
    staff_id: appointmentForm.staff_id === "unassigned" ? null : appointmentForm.staff_id || null,
    start_time: toIso(appointmentForm.start_time),
    end_time: toIso(appointmentForm.end_time),
  };
  if (appointmentForm.historical_outcome) {
    payload.historical_outcome = appointmentForm.historical_outcome;
  }
  return payload;
};
